import React from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { Avatar } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";

const useStyles = makeStyles({
  root: {
    maxWidth: "448px",
  },
  text: {
    margin: "30.5px 0 14.9px",
    fontSize: "16px",
    fontWeight: "500",
    lineHeight: "1.94",
    textAlign: "left",
    color: "#1e2f4f",
  },
  tyrionLannister: {
    width: "109px",
    height: "18px",
    margin: "0 0 8px",
    fontSize: "15px",
    fontWeight: "bold",
    lineHeight: "1.2",
    letterSpacing: "normal",
    textAlign: "left",
    color: "#1e2f4f",
  },
  ceoCompany: {
    width: "58px",
    height: "11px",
    margin: "8px 51px 0 0",
    fontSize: "9px",
    fontWeight: "500",
    lineHeight: "1.22",
    letterSpacing: "normal",
    textAlign: "left",
    color: "#747f92",
  },
  avatar: {
    left: "18px",
    width: "59.5px",
    height: "59.5px",
    margin: "0 29.2px 0 0",
  },
});

export const TestimonyCard = ({ cardInfo }) => {
  const classes = useStyles();
  const { image, cardText, clientName, position } = cardInfo;
  return (
    <Card className={classes.root}>
      <CardContent>
        <Grid className={classes.text}>{cardText}</Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
        >
          <Avatar alt={clientName} src={image} className={classes.avatar} />
          <span>
            <Typography
              variant="body2"
              component="span"
              color="textPrimary"
              className={classes.tyrionLannister}
            >
              <b>{clientName}</b>
            </Typography>
            <br />
            <Typography
              variant="body2"
              component="span"
              color="textSecondary"
              className={classes.ceoCompany}
            >
              {position}
            </Typography>
          </span>
        </Grid>
      </CardContent>
    </Card>
  );
};
TestimonyCard.propTypes = {
  cardInfo: PropTypes.instanceOf(Object).isRequired,
};
